<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px" v-if="contrato && contrato._id">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/concentradores">CONCENTRADORES</a></li>
                    <li class="active">COMANDOS PARA O CONCENTRADORES</li>
                </ol>

                <div class="col-md-3">
                    <concentrador-menu :concentrador="contrato"></concentrador-menu>
                </div>
                <div class="col-md-9"  v-if="contrato._id">

                    <status-ping v-if="contrato.ssh" :ip="contrato.ssh.host"></status-ping>

                    <form class="form-horizontal" >

                        <div class="form-group">
                            <div class="col-sm-6">
                                <label class="control-label">NOME DO CONCENTRADOR</label>
                                <input disabled type="text" v-model="contrato.nome" class="form-control" >
                            </div>
                            <div class="col-sm-6">
                                <label class="control-label">INTERFACE DO CONCENTRADOR</label>
                                <input disabled type="text" v-model="contrato.interface" class="form-control" >
                            </div>
                        </div>

                        <div class="panel panel-info">
                            <div class="panel-heading">COMANDOS PERSONALIZADOS</div>
                            <div class="panel-body" >

                                <div class="form-group">
                                    <div class="col-sm-12">
                                        <label for="inputIp" class="control-label">COMANDO A SER ENVIADO:</label>
                                        <textarea rows="5" v-model="comando.comando" class="form-control" id="inputIp"></textarea>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-sm-10">
                                        <button :disabled="!comando.comando" type="button" @click="send()" class="btn btn-success">ENVIAR COMANDO</button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Concentrador } from "../../../class/index";
import { router } from "../../../router";

import { StatusPing, ConcentradorMenu } from "../../../components/exports";

export default {
    components: {
        ConcentradorMenu,
        StatusPing
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.load(this.$route.params.id);
        } else {
            this.contrato = Concentrador.create();
        }
    },
    data() {
        return {
            contrato: null,
            user: null,
            comando: {
                comando: null,
                contratos: []
            }
        };
    },
    methods: {
        load(id) {
            Concentrador.byID(id)
                .then(row => {
                    this.contrato = row;
                    this.comando.contratos.push(row._id);
                })
                .catch(err => console.error(err));
        },
        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Enviar Comando",
                    text: "Posso enviar o comando?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            this.comando.contrato_id = this.contrato._id;

                            Concentrador.sendComandoAll(this.comando)
                                .then(() => {
                                    this.$emit("comandos");
                                    this.comando.comando = null;
                                    resolve();
                                })
                                .catch(err => {
                                    if (err.status) {
                                        swal(
                                            "Roteador OFFLINE!",
                                            "Roteador não pinga!",
                                            "error"
                                        );
                                    }
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
